import React, { FunctionComponent } from 'react';
import { Redirect } from 'react-router-dom';
import { useAccount } from '../../hooks/useAccount';
import { useBriefsOverview } from '../../hooks/useBriefs';
import { useFeatureFlag, useFeatureFlags } from '../../hooks/useFeatureFlag';
import { Account } from '../../services/models/account';
import { FeatureFlag } from '../../services/models/feature-flags';
import { SocialRoute } from '../../utils/Routes';
import LoadingSpinner from '../loading-spinner/LoadingSpinner';

const DashboardRedirection: FunctionComponent = () => {
  const { account: currentAccount } = useAccount();
  const account = currentAccount as Account;
  const { briefs: briefItems, loading: isFetchingBriefs } = useBriefsOverview();
  const briefs = { items: briefItems };
  const { loading: isFetchingFlags } = useFeatureFlags();
  const isFetching = isFetchingFlags || isFetchingBriefs;

  const socialBriefFlag = useFeatureFlag(FeatureFlag.ShowSocialBrief);

  if (isFetching) {
    return <LoadingSpinner />;
  }

  if (briefs && briefs.items && briefs.items.length > 0) {
    return <Redirect to={`/dashboard/brief/${briefs.items[0].id}`} />;
  }

  // TODO: Redirect to Social check
  if (socialBriefFlag && account.metadata?.isTwitterUser) {
    return <Redirect to={SocialRoute} />;
  }

  return <Redirect to="/dashboard/brief" />;
};

export default DashboardRedirection;
